// extracted by mini-css-extract-plugin
module.exports = {"sign-up":"sign-up_sign-up__QaNmZ","title":"sign-up_title__3GnoB"};